
//calculate existing balance factor using measured mass
function calculateBalanceFactor(
  rodSmallEndMass,   // g
  hungMass,          // g
  pistonAssemblyMass // g
) {

  const numerator = hungMass + rodSmallEndMass;
  const denominator = rodSmallEndMass + pistonAssemblyMass;
  const balanceFactor = (numerator / denominator) * 100;
  const recipMass = rodSmallEndMass + pistonAssemblyMass;

  return {balanceFactor,recipMass};
}

//Events
    //-----------------------CALCULATOR 1 --------------------------------
    // Event for Balance Factor inputvariables
    document.getElementById("calculator1").addEventListener("submit", function(event) {
      event.preventDefault();

      const rodSmallEndMass = Number(document.getElementById("rodSmallEndMass").value);
      const hungMass = Number(document.getElementById("hungWeight").value);
      const pistonAssemblyMass = Number(document.getElementById("pistonAssemblyMass").value);
      const result = calculateBalanceFactor(rodSmallEndMass, hungMass, pistonAssemblyMass);
        balanceFactor = result.balanceFactor;
        recipMass = result.recipMass;
    
    // write Balance factor variables
      document.getElementById("result1").innerHTML =
        "Balance Factor: " + balanceFactor.toFixed(2) + "%<br><br>" ;//+
        //"Reciprocating Mass: "  + recipMass.toFixed(2) + "g<br><br>";
    });